export class ROUTE_PARAM {
  static readonly MELDING = 'meldingGuid';
}

export class ROUTE {
  static readonly ROOT = '/';
  static readonly HOME = '';
  static readonly OVERZICHT = 'overzicht';
  static readonly DASHBOARD = 'dashboard';

  static readonly APPLICATIEBEHEER = 'applicatiebeheer';

  static readonly TOKEN = 'token';
  static readonly LOGIN = 'login';
  static readonly LOGOUT = 'logout';
  static readonly LOGGEDOUT = 'loggedout';

  static readonly UNAUTHORISED = '401';
  static readonly FORBIDDEN = '403';

  static readonly DOSSIER = 'dossier';
  static readonly DOSSIER_DETAIL_CHILD = `/:${ROUTE_PARAM.MELDING}`;
}
